<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [(ngModel)]="value"
  nzShowSearch
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="true"
  [nzDropdownMatchSelectWidth]="false"
  [required]="isRequired"
>
  <nz-option
    *ngFor="let item of options"
    [nzValue]="item.code"
    [nzLabel]="item.code + ' - ' + item.description"
    nzCustomContent
  >
    <div class="dropdown-container">
      <strong>{{ item.code }}</strong>
      -
      <span> {{ item.description }}</span>
    </div>
  </nz-option>
</nz-select>
